/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { patchState, signalStoreFeature, withMethods, withState } from "@ngrx/signals";

export const initialState: DatesFilterState = { fromDate: "", toDate: "" };

export interface DatesFilterState {
  fromDate: string;
  toDate: string;
}

export function withDatesFilter() {
  return signalStoreFeature(
    withState<DatesFilterState>(initialState),
    withMethods(store => ({
      setDatesFilter(fromDate: string, toDate: string): void {
        patchState(store, { fromDate, toDate });
      },
    })),
  );
}
